import type { ComponentType } from 'react';
import {
	AiChatEntryPoint_Clicked,
	BrowseInvestments_Clicked,
	Home_Clicked,
	Origin,
	Transfer_Clicked,
} from '@stashinvest/product-events-typescript';

import {
	ArrowsLeftRightIcon,
	HouseIcon,
	BinocularsIcon,
	SparkleIcon,
} from '@stashinvest/react-assets';

type ProductEventPayload = {
	event: string;
	properties?: Record<string, unknown>;
	context?: Record<string, unknown>;
	metric: string;
};

export type NavRailOption = {
	Icon: ComponentType;
	to: string;
	title?: string;
};

export type NavOption = {
	event: (props: { origin: typeof Origin.rail }) => ProductEventPayload;
	banjoId: string;
	urlMatches: string[];
	railOption: NavRailOption;
};

export const HOME_NAV_BANJO_ID = 'navigation/navigate/myStash';

export const HOME_NAV_OPTION: NavOption = {
	event: Home_Clicked.v2,
	banjoId: HOME_NAV_BANJO_ID,
	urlMatches: ['/$'],
	railOption: { Icon: HouseIcon, to: '/' },
};

export const TRANSFER_NAV_OPTION: NavOption = {
	event: Transfer_Clicked.v2,
	banjoId: 'navigation/navigate/transfer',
	urlMatches: ['/transfer.*'],
	railOption: {
		Icon: ArrowsLeftRightIcon,
		to: '/transfer',
	},
};

export const INVEST_NAV_OPTION: NavOption = {
	event: BrowseInvestments_Clicked.v1,
	banjoId: 'navigation/navigate/invest',
	urlMatches: ['/browse-collection.*'],
	railOption: {
		Icon: BinocularsIcon,
		to: '/browse-collection',
	},
};

export const COACH_NAV_OPTION: NavOption = {
	event: AiChatEntryPoint_Clicked.v1,
	banjoId: 'navigation/navigate/coach',
	urlMatches: ['^/money-coach(?:/.*)?$', '^/coach(?:/.*)?$'],
	railOption: {
		Icon: SparkleIcon,
		to: '/money-coach',
	},
};
